const DESC_CHANGE_PREFIX = '[SH_DESC_CHANGE:v1:';
const DESC_CHANGE_SUFFIX = ']';

export function encodeDescriptionChangeMessage(displayText, { oldDescription, newDescription }) {
  const payload = btoa(
    unescape(
      encodeURIComponent(
        JSON.stringify({
          old: oldDescription ?? '',
          new: newDescription ?? '',
        })
      )
    )
  );
  return `${DESC_CHANGE_PREFIX}${payload}${DESC_CHANGE_SUFFIX}${displayText}`;
}

export function parseDescriptionChangeMessage(content) {
  if (!content || !content.startsWith(DESC_CHANGE_PREFIX)) {
    return { displayText: content, meta: null };
  }

  const end = content.indexOf(DESC_CHANGE_SUFFIX);
  if (end === -1) {
    return { displayText: content, meta: null };
  }

  const payloadB64 = content.slice(DESC_CHANGE_PREFIX.length, end);
  const displayText = content.slice(end + DESC_CHANGE_SUFFIX.length);

  try {
    const json = JSON.parse(decodeURIComponent(escape(atob(payloadB64))));
    return {
      displayText,
      meta: {
        oldDescription: json.old ?? '',
        newDescription: json.new ?? '',
      },
    };
  } catch {
    return { displayText: content, meta: null };
  }
}

export function splitTextAtDescriptionWord(displayText) {
  const marker = 'descrição';
  const index = displayText.indexOf(marker);

  if (index === -1) {
    return { before: displayText, link: null, after: '' };
  }

  return {
    before: displayText.slice(0, index),
    link: marker,
    after: displayText.slice(index + marker.length),
  };
}
